import { render } from "./TopNeeds.vue?vue&type=template&id=309dc228"
import script from "./TopNeeds.vue?vue&type=script&lang=js"
export * from "./TopNeeds.vue?vue&type=script&lang=js"
script.render = render

export default script